<template>
  <div class="header">
    <div class="content">
      <img class="logo" src="../assets/header-logo.png">
      <div class="buttons">
        <div class="button"  @click="routerTo('/')">HOME</div>
        <div class="button" @click="routerTo('eblocks')">E-BLOCKS</div>
        <div class="button" @click="routerTo('curriculum')">CURRICULUM</div>
        <div class="button" @click="routerTo('franchise')">FRANCHISE</div>
        <div class="button" @click="routerTo('about')">ABOUT US</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    routerTo(name){
      this.$router.push(name)
    }
  }
}
</script>

<style scoped lang="less">

  @import "../assets/style/index";

  .header{
    height: 106px;
    background: #6D43A1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 2;
    .content{
      .media-content;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .logo{
        width: 98px;
        height: 75px;
      }
      .buttons{
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 36px;
        font-size: 18px;
        color: white;
        height: 100%;
        font-family: 'ArialMT', Helvetica, Arial, sans-serif;
        .button{
          height: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 20px 10px 0 10px;
          cursor: pointer;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/e-header.vue